import api from '../services/api';

const BASE = '/api/v1/admin/notifications';

const emailAdminService = {
  async listProviders() {
    const { data } = await api.get(`${BASE}/email-providers`);
    return data;
  },
  async createProvider(payload) {
    const { data } = await api.post(`${BASE}/email-providers`, payload);
    return data;
  },
  async updateProvider(id, payload) {
    const { data } = await api.put(`${BASE}/email-providers/${id}`, payload);
    return data;
  },
  async deleteProvider(id) {
    await api.delete(`${BASE}/email-providers/${id}`);
  },
  async activateProvider(id) {
    const { data } = await api.post(`${BASE}/email-providers/${id}/activate`);
    return data;
  },
  async testProvider(id, to) {
    const { data } = await api.post(`${BASE}/email-providers/${id}/test`, { to });
    return data;
  },
  async listTemplateTypes() {
    const { data } = await api.get(`${BASE}/email-templates/types`);
    return data;
  },
  async listTemplates(templateType) {
    const params = templateType ? { template_type: templateType } : {};
    const { data } = await api.get(`${BASE}/email-templates`, { params });
    return data;
  },
  async createTemplate(payload) {
    const { data } = await api.post(`${BASE}/email-templates`, payload);
    return data;
  },
  async updateTemplate(id, payload) {
    const { data } = await api.put(`${BASE}/email-templates/${id}`, payload);
    return data;
  },
  async deleteTemplate(id) {
    await api.delete(`${BASE}/email-templates/${id}`);
  },
  async activateTemplate(id) {
    const { data } = await api.post(`${BASE}/email-templates/${id}/activate`);
    return data;
  },
  async previewTemplate(payload) {
    const { data } = await api.post(`${BASE}/email-templates/preview`, payload);
    return data;
  },
  async testTemplate(id, to, variables) {
    const { data } = await api.post(`${BASE}/email-templates/${id}/test`, { to, variables });
    return data;
  },
};

export default emailAdminService;
